// engine จำลอง (โหมดทดลอง / เบราว์เซอร์ไม่มี WebGPU ในโหมดทดลอง) — ไม่โหลดโมเดล ตอบข้อความตัวอย่าง และประมาณจำนวน token
import { estimateTokens } from "./tokens";

const SAMPLES = [
  "นี่คือคำตอบจาก **โหมดทดลอง** ของ MixAI ครับ\n\nเมื่อเชื่อมต่อ Firebase และเปิดใช้ AI ในเบราว์เซอร์ คำตอบจะมาจากโมเดลจริงที่รันในเครื่องคุณ\n\n- ข้อมูลไม่ถูกส่งออกไปภายนอก\n- คิดค่าบริการตามจำนวน token ที่ใช้จริง\n- เปลี่ยนโมเดลได้ทุกเมื่อจากเมนูด้านบน",
];

export function createMockBackend() {
  return {
    mock: true,
    alwaysReady: true,
    supported: () => true,
    isCached: async () => true,
    load: async () => {},
    unload: async () => {},
    interrupt: () => {},
    async *stream(req) {
      const last = [...(req.messages || [])].reverse().find((m) => m.role === "user");
      const q = String(last ? last.content : "").slice(0, 120);
      const text = `${SAMPLES[0]}\n\n> คุณถามว่า: ${q}`;
      for (let i = 0; i < text.length; i += 5) {
        await new Promise((r) => setTimeout(r, 18));
        yield text.slice(i, i + 5);
      }
      if (req.onUsage) {
        const prompt = (req.messages || []).reduce((n, m) => n + estimateTokens(m.content), 0);
        req.onUsage({ prompt, completion: estimateTokens(text) });
      }
    },
  };
}
